export default {
  SET_INVENTORY(state, inventory) {
    state.inventory = inventory
  },
  UPDATE_INVENTORY(state, inventory) {
    state.inventory.push(...inventory)
  },
}
